import React from 'react'
import DialogService from 'components/Dialog/DialogService'
import { useOldNativeVersionDialog } from 'components/OldNativeVersionDialog/useOldNativeVersionDialog'
import OldNativeVersionDialog from 'redesign/components/organisms/OldNativeVersionDialog'
import DashboardHeader from 'redesign/components/organisms/headers/DashboardHeader'
import DashboardContent from 'redesign/components/templates/DashboardContent'
import Page from 'redesign/components/templates/Page'
import { STANDARD_PAGE_HORIZONTAL_PADDING } from 'shared/constants'
import { isNative } from 'utils/platform'
import { useDashboardPage } from './useDashboardPage'

const DashboardPage: React.FC = () => {
  const {
    header,
    isLoading,
    isManager,
    isNoOverrideNative,
    taskSection,
    shiftsSection,
    quickLinksSection,
    hasAccessToModuleShiftPlan,
    hasAccessToModuleTasks,
  } = useDashboardPage()

  const { showDialog, nativeVersion, platformText, onClose } = useOldNativeVersionDialog({ showOnlyOnce: true })

  return (
    <>
      <Page
        paddingX={STANDARD_PAGE_HORIZONTAL_PADDING}
        header={<DashboardHeader header={header} isNative={isNative()} />}
      >
        <DialogService subscribed={['securityTimeout', 'securitySetup', 'pinReset', 'pinChange']} />
        <DashboardContent
          isLoading={isLoading}
          isManager={isManager}
          taskSection={taskSection}
          shiftsSection={shiftsSection}
          quickLinksSection={quickLinksSection}
          hasAccessToModuleShiftPlan={hasAccessToModuleShiftPlan}
          hasAccessToModuleTasks={hasAccessToModuleTasks}
        />
      </Page>
      {isNoOverrideNative && (
        <OldNativeVersionDialog
          onClose={onClose}
          platform={platformText}
          showDialog={showDialog}
          nativeVersion={nativeVersion}
        />
      )}
    </>
  )
}

export default DashboardPage
